import { createEntityFilterStore } from "./createEntityFilterStore";
import type { ProjectFilters } from "@/domain/types";

const buildInitialFilters = (): ProjectFilters => ({
	search: "",
	beneficiary: "",
	subtype: "",
	status: "",
	documentation: "",
	fiscal_year: `${new Date().getFullYear()}`,
	sort: { key: undefined, direction: null },
});

export const useProjectFiltersStore = createEntityFilterStore<ProjectFilters>(
	"ProjectFiltersStore",
	buildInitialFilters,
);
